import { MyLoanInfo } from "pages/application/applicationService";

/**
 * Returns Encompass portfolio rows for the sidebar LOAN section.
 * When dual-LOS is disabled, the my-loans API is Encompass-only per US-04.
 */
export const filterEncompassLoans = (
  loans: MyLoanInfo[] | undefined,
  dualLosPortfolioEnabled = false,
): MyLoanInfo[] => {
  if (!loans?.length) {
    return [];
  }

  if (!dualLosPortfolioEnabled) {
    return loans;
  }

  return loans.filter((loan) => {
    const losType = (loan as MyLoanInfo & { losType?: string }).losType;
    return !losType || losType === "encompass";
  });
};
